import { createPubSub } from 'js/tools';

export default context => {
    const refs = {
        inputText: context.querySelector('.input-text input[type=search]')
    };

    const pubsub = createPubSub();

    function init() {
        refs.inputText.addEventListener('blur', submit);
        refs.inputText.addEventListener('keyup', handleKeyUp);
    }

    function handleKeyUp(e) {
        if (e.keyCode === 13) {
            submit();
        }
    }

    function submit() {
        pubsub.publish('submit');
    }

    init();

    return {
        refs,
        subscribeToEvent: pubsub.subscribe
    };
};
